import React from 'react';
import s from "./DigitalAssetsBanking.module.css";
import coins from "../../assets/img/coins.png";
import CustomBtnPink from "../../components/ui/customBtnPink/CustomBtnPink";
import { useNavigate } from "react-router-dom";
import { OPEN_ACCOUNT } from "../../router/Constants";
import { motion } from 'framer-motion';
import Hero from '../../components/hero/Hero';
import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet-async";

const DigitalAssetsBanking = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className={s.wrapper}>

            <Helmet>
                <title>Digital Assets Banking Solutions | Wall Street IBU</title>
                <meta
                    name="description"
                    content="Modern digital assets banking solutions built on secure, compliant infrastructure.
                    Global transactions and innovative banking with Wall Street IBU."
                />
                <meta name="keywords" content="global digital bank, international banking card, digital assets banking, international banking card"/>
            </Helmet>

            <motion.div
                initial={{ opacity: 0, scale: 1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className={s.motion_div}
            >
                <div className={s.content}>
                    <Hero
                        title_1={t('digitalAssetsBanking.hero.title_1')}
                        title_2={t('digitalAssetsBanking.hero.title_2')}
                        description={t('digitalAssetsBanking.hero.description')}
                    />
                    <div className={s.coins_block}>
                        <div className={s.coins_description_block}>
                            {t('digitalAssetsBanking.coins_block.description')}
                        </div>
                        <div className={s.coins_img_block}>
                            <img src={coins} alt=""/>
                        </div>
                    </div>
                </div>

                <div className={s.content}>
                    <div className={s.flex}>
                        <div className={s.left}>
                            <div className={s.mb}>
                                {t('digitalAssetsBanking.flex.left')}
                            </div>
                        </div>
                        <div className={s.right}>
                            {t('digitalAssetsBanking.flex.right')}
                        </div>
                    </div>

                    <div className={s.services_list_block}>
                        <div className={s.services_list_block_title}>
                            {t('digitalAssetsBanking.services_list_block.title')}
                        </div>
                        <div className={s.flex}>
                            <div className={s.left_list_block}>
                                <div className={s.line}>
                                    <div className={s.check_circle} />
                                    <div className={s.line_desc}>
                                        <div className={s.line_title}>
                                            {t('digitalAssetsBanking.services_list_block.left_list_block.line1.title')}
                                        </div>
                                        <div className={s.line_text}>
                                            {t('digitalAssetsBanking.services_list_block.left_list_block.line1.text')}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.line}>
                                    <div className={s.check_circle} />
                                    <div className={s.line_desc}>
                                        <div className={s.line_title}>
                                            {t('digitalAssetsBanking.services_list_block.left_list_block.line2.title')}
                                        </div>
                                        <div className={s.line_text}>
                                            {t('digitalAssetsBanking.services_list_block.left_list_block.line2.text')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={s.right_list_block}>
                                <div className={s.line}>
                                    <div className={s.check_circle} />
                                    <div className={s.line_desc}>
                                        <div className={s.line_title}>
                                            {t('digitalAssetsBanking.services_list_block.right_list_block.line1.title')}
                                        </div>
                                        <div className={s.line_text}>
                                            {t('digitalAssetsBanking.services_list_block.right_list_block.line1.text')}
                                        </div>
                                    </div>
                                </div>
                                <div className={s.line}>
                                    <div className={s.check_circle} />
                                    <div className={s.line_desc}>
                                        <div className={s.line_title}>
                                            {t('digitalAssetsBanking.services_list_block.right_list_block.line2.title')}
                                        </div>
                                        <div className={s.line_text}>
                                            {t('digitalAssetsBanking.services_list_block.right_list_block.line2.text')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={s.gradient_block}>
                        <div className={s.gradient_block_overlay}>
                            <div className={s.open_text}>
                                {t('digitalAssetsBanking.gradient_block.open_text1')}
                            </div>
                            <div className={s.open_text}>
                                {t('digitalAssetsBanking.gradient_block.open_text2')}
                            </div>
                            <div className={s.btn_block}>
                                <div className={s.btn_wrapper}>
                                    <CustomBtnPink
                                        title={t('digitalAssetsBanking.gradient_block.btn_title')}
                                        onClick={() => navigate(OPEN_ACCOUNT)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </motion.div>
        </div>
    );
};

export default DigitalAssetsBanking;
